'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MuiThemeProviderContainer = exports.muiThemeProviderBuilder = undefined;

var _reactRedux = require('react-redux');

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var muiThemeProviderBuilder = exports.muiThemeProviderBuilder = function muiThemeProviderBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_MuiThemeProvider2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    muiTheme: state.theme
  };
};

var MuiThemeProviderContainer = exports.MuiThemeProviderContainer = muiThemeProviderBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/MuiThemeProviderContainer/MuiThemeProviderContainer.js
 ** module id = 475
 ** module chunks = 0
 **/